import contract from '@mailobj-browser/front/js/contracts/contract.js'
import addresses from './addresses/addresses.js'
import groups from './groups/groups.js'

export default contract({
    addresses,
    groups
})